import axios from '../../../axios';
import IClientInvoice from '../types/IClientInvoice';

const url = '/invoicingservice/api/client-invoicing';

export const createClientInvoice = (clientInvoice: IClientInvoice) =>
  axios.post(url + '/add', clientInvoice);
export const updateClientInvoice = (clientInvoice: IClientInvoice) =>
  axios.put(url + `/${clientInvoice.id}/edit`, clientInvoice);
export const getClientInvoiceList = (pageNo = 0, pageSize = 5) =>
  axios.get(`${url}/list?pageNo=${pageNo}&pageSize=${pageSize}`);
export const updateInvoiceStatus = (data: any) => axios.put(`${url}/updatestatus`, data);
